(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // directive for daytask-list
    module.directive('agendaDaytask', ['$rootScope', '$compile',  '$anchorScroll', 'QuickSidebarTasksService', 'DayTaskBroadcast', 'HelperService',
        function ($rootScope, $compile, $anchorScroll, QuickSidebarTasksService, DayTaskBroadcast, HelperService) {
        var directive = {
            restrict: 'A',
            templateUrl: '/app/agenda/templates/agenda-daytask.template.html',
            controller: 'AgendaDaytaskController',
            controllerAs: 'vm',
            scope: {
                task: '='
            },
            bindToController: true,
            link: link
           
        };
        return directive;
       
        function link(scope, element) {  
            // if element is clicked -> open task-reactions
            var actions = element.find('#actions');
            // show div or not 
            var reply = true;

            activate();

            function activate() {
                if (QuickSidebarTasksService.data.current !== null && 
                    scope.vm.task.id === QuickSidebarTasksService.data.current.id) {
                    // reset clicked quick sidebar reaction
                    QuickSidebarTasksService.data.current = null; 
                    // show task-reaction
                    showReaction(true);
                } // if
            } // activate

            // if abort-button is clicked
            element.on('click', function (e) {
                if (!reply) { return; }

                // has been created the element ?
                var tra = element.find('task-reaction-add')[0];
                if (tra) {                    
                    var saveButton = element.find('#reaction_save')[0];
                    if (saveButton) {                            
                        saveButton.scrollIntoView(false);
                    } 
                    return false;
                }

                // create the element
                showReaction(true);
                                              
                return true;
            });

            // show reaction-add element
            function showReaction(scroll) {
                // broadcast message to close all other <task-reaction-add> components
                $rootScope.$broadcast(
                    DayTaskBroadcast.ShowReaction, scope.vm.task.id);
                
                // create the element
                var el = $compile("<task-reaction-add class='move' task='vm.task'></task-reaction-add>")(scope);
                element.find('#reaction-list').append(el);                
                if (scroll) {
                    setTimeout(function() {                        
                        var saveButton = element.find('#reaction_save')[0];
                        if (saveButton) {                            
                            saveButton.scrollIntoView(false);
                        }                        
                     }, 0); 
                }
                el = null;
            }

            // if mouseover the action-buttons
            actions.on('mouseenter', function (e) {
                reply = false;
            });

            actions.on('mouseleave', function (e) {
                reply = true;
            });


            scope.$on('$destroy', function () {
                element.off('click');
                actions.off('mouseenter');
                actions.off('mouseleave');
                actions = null;
                reply = null;
            });

        }

    }]);

})();